import React, { useEffect, useState } from 'react';
import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import Translator from '../../../../../../components/helpers/Translator';

const ChangeBlockEvidenceCloneForm = (props) => {
  const { handleCloneEvidence, value } = props;
  const dispatch = useDispatch();
  const { plantHex } = useParams();
  const [evidenceList, setEvidenceList] = useState();

  const getEvidenceList = async () => {
    const response = await axios.post(
      axiosPath(
        "api_r_user_module_legalCompliance_blockChange_getEvidenceList"
      ),
      { plantHex }
    );
    return response.data;
  };

  useEffect(() => {
    getEvidenceList().then((r) => setEvidenceList(r));
  }, []);

  return (
    <>
      <AppMultiSelect
        title={<Translator file="module-legalCompliance" name="evidences" />}
        icon={<AppRemixIcon icon="home" />}
        value={value}
        options={evidenceList}
        onChange={(opt) => handleCloneEvidence(opt)}
        isLoading={!evidenceList}
        hasSearchBox
        hasSelectOptions
      />
    </>
  );
};
export default ChangeBlockEvidenceCloneForm;
